import React, { PropsWithChildren, ReactElement } from 'react';

export default function SimpleLayout({
  children,
}: PropsWithChildren<any>): ReactElement {
  return <div className="simple-layout">{children}</div>;
}
